import TspApiService from "../../api/tspApiService";
import useTspApiResource from "../../hooks/useTspApiResource";
import useTspPermission from "../../hooks/useTspPermission";
import TSP_PERMISSIONS from "../../constants/tspPermissions";

const NOTHING = () => Promise.resolve({ data: null });

// One city, every section, in a single request (GET /api/tsp/knowledge/:locationId).
// `locationId` null (an unusable link) -> nothing is requested.
export function useTspCityKnowledge(locationId) {
  return useTspApiResource(() => (locationId ? TspApiService.knowledge.get(locationId) : NOTHING()), [locationId]);
}

// The caller's flags the knowledge sections read (CitySections.jsx): which
// record types they may see, and whether they may add advice.
export function useTspKnowledgePerms() {
  const { hasPermission } = useTspPermission();
  return {
    viewMedia: hasPermission(TSP_PERMISSIONS.MEDIA_VIEW),
    viewAdvice: hasPermission(TSP_PERMISSIONS.ADVICE_VIEW),
    manageAdvice: hasPermission(TSP_PERMISSIONS.ADVICE_MANAGE),
    viewContacts: hasPermission(TSP_PERMISSIONS.CONTACTS_VIEW),
    viewAccommodation: hasPermission(TSP_PERMISSIONS.ACCOMMODATION_VIEW),
    viewPrasadam: hasPermission(TSP_PERMISSIONS.PRASADAM_VIEW),
    viewLocations: hasPermission(TSP_PERMISSIONS.LOCATIONS_VIEW),
  };
}
